<template>
<div>
  <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div v-else class="invoice-create-page">
    <!--  credit form component -->
    <CustomerAdvanceForm
      page="create"
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      v-on:FormUpdate="FormUpdate = 1"
      v-on:onSubmit="onSubmit($event)"
    ></CustomerAdvanceForm>
  </div>
  </div>
</template>

<script>
import CustomerAdvanceForm from "@/components/Form/CustomerAdvance/CustomerAdvanceForm"; // customer advance form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  name: "PaymentCreate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    CustomerAdvanceForm,
    RecordNotFound
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.$store
        .dispatch("customeradvance/createList", data)
        .then(() => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
         
          if (this.status_code == 200) {
            var saved_data = JSON.parse(data);

            if (saved_data.header_details.cus_adv_desc_changed) {
              this.cus_adv_settings_details.cus_inv_notes =
                saved_data.header_details.cus_inv_notes;
            }
            //  show if invoice successfully created
            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.message,
              type: "success",
              showCloseButton: true
            });
           //  show if invoice successfully created
            if(this.RoutePermission(false,'','','paymentsreceived','index')){
                 this.$router.push({
              name: "CustomerAdvanceView",
              params:{
              id:this.payment_hdr
              }
            });
            }
            else{
            this.$router.push({
              name: "CustomerAdvance"
            });
            }
          } else {
            this.duplicatecode = true;
            this.submitted = false;
          }
        })
        .catch(() => {});
    }
  },
  async beforeRouteEnter(routeTo, routeFrom, next) {
   await  store
      .dispatch(
        "payment/fetchPaymentmethod",
        JSON.stringify({
          type: "customer_advance"
        })
      )
      .then(() => {
        next();
      });
        await store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Customer Advance",
        stg_name: "cus_adv_settings_details"
      })
      .then(() => {
        next();
      });

  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  updated: function() {},
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.customeradvance.code,
      message: state => state.customeradvance.message,
      type: state => state.customeradvance.type,
      status_code: state => state.customeradvance.status_code, 
      status_message: state => state.customeradvance.status_message, 
      status_type: state => state.customeradvance.status_type,
      payment_hdr:state => state.customeradvance.payment_hdr
    }),
    cus_adv_settings_details: {
      get() {
        return this.$store.state.permission.cus_adv_settings_details;
      },
      set(val) {
        this.$store.state.permission.cus_adv_settings_details = val;
      }
    }
  }
};
</script> 

<style>
</style>
